<template>
    <div id="signin" class="container-fluid" style="min-height: 85vh; padding: 80px; background-color: #E8E8E8;">
        <div class="signin-form">
            <h2 align="center">
                <img src="../../assets/logo.png" height="200" class="d-inline-block align-top" alt="YMD">
                <br/>
                Account Login
            </h2>
            <form @submit.prevent="onSubmit"
                  @keydown="form.errors.clear($event.target.name)"
                  @change="form.errors.clear($event.target.name)"
                  @click.right="form.errors.clear($event.target.name)"
            >
                <div class="input">
                    <label for="email">Email</label>
                    <input
                            :class="{'is-danger-input': form.errors.has('email')}"
                            type="email"
                            id="email"
                            v-model="form.email">
                    <span class="help is-danger" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
                </div>
                <div class="input">
                    <label for="password">Password</label>
                    <input
                            :class="{'is-danger-input': form.errors.has('password')}"
                            type="password"
                            id="password"
                            v-model="form.password">
                    <span class="help is-danger" v-if="form.errors.has('password')" v-text="form.errors.get('password')"></span>
                </div>

                <b-alert v-if="form.errors.error.title || form.errors.error.message" show variant="warning">
                    <span class="help is-danger">
                        <icon name="warning" scale="0.9"></icon> &nbsp;
                        <strong v-if="form.errors.error.title">{{form.errors.error.title}}: <br/></strong>
                        {{form.errors.error.message}}
                    </span>
                </b-alert>

                <div class="submit">
                    <button type="submit" class="btn btn-success" :disabled="form.errors.any() || form.isDisabled">Log in now</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
  import {Form, Errors} from '@/components/validations/forms';
  import router from './../../router'

  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
    data () {
      return {
        form: new Form({
          name: null,
          company: null,
          email: '',
          password: '',
          password_confirmation: '',
          isDisabled: false,
        }),
      }
    },
    props: ['redirect'],
    methods: {
      onSubmit () {
        this.form.isDisabled = true;
        this.$store.dispatch('auth/login', this.form)
          .then(response => {
            this.form.onSuccess(response);
            if(this.redirect){router.replace(this.redirect)} else{router.replace('/hr/dashboard')};
            this.form.isDisabled = false;
          })
          .catch(error => {
//            alert(JSON.stringify(error))
            this.form.onFail(error);
            this.form.isDisabled = false;
//            this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
          })
      }
    }
  }
</script>

<style scoped>
    .signin-form {
        width: 400px;
        margin: 30px auto;
        border: 1px solid #eee;
        padding: 20px;
        box-shadow: 0 2px 3px #ccc;
        background-color: white;
        padding-bottom: 50px;
    }

    .input {
        margin: 10px auto;
    }

    .input label {
        display: block;
        color: #4e4e4e;
        margin-bottom: 6px;
    }

    .input input {
        font: inherit;
        width: 100%;
        padding: 6px 12px;
        box-sizing: border-box;
        border: 1px solid #ccc;
    }

    .input input:focus {
        outline: none;
        border: 1px solid #521751;
        background-color: #eee;
    }

    .submit{
        float: right;
    }

    .submit button[disabled],
    .submit button[disabled]:hover,
    .submit button[disabled]:active {
        border: 1px solid #ccc;
        background-color: transparent;
        color: #ccc;
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// src/components/login/login.vue